// Module
var code = "<div id=\"people-container\" class=\"row px-2 pt-2\"> </div>";
// Exports
export default code;